import StyleStack from "../../../../../../Reuse/UI/StyleStack";
import { Divider, Stack, Typography } from "@mui/material";
import TurnRightRoundedIcon from "@mui/icons-material/TurnRightRounded";
import React from "react";
import { DroneNestIcon, BatteryIcon } from "../../../../../../Reuse/Icon";
import Title from "./Title";
import { DroneIcon, droneStatus, droneTypes } from "../../../Context";
import OverflowTooltip from "../../../../../../Reuse/UI/OverflowTooltip";
const DroneDetail = (props) => {
  const {
    status = "AVAILABLE",
    battery_level = 0,
    divStatus = "available",
    display_id = "",
    device_id = "",
    drone_nest = {},
    weapon = [],
    showOnMap = () => undefined,
    isShowDroneNest = true,
  } = props;
  console.info("DroneDetail props:", props);
  const drone_status = droneStatus.filter((el) => el.value === status);

  return (
    <StyleStack
      direction={"column"}
      gap={1}
      sx={{ width: "100%", paddingY: 1, paddingX: 1.5 }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ width: "100%" }}
      >
        <Title
          title={`${device_id || "NA"}`}
          title1={`${display_id || "NA"}`}
          divStatus={divStatus}
          status={drone_status?.at(0).label}
        />
        {!!showOnMap ? (
          <Stack
            direction={"row"}
            alignItems={"center"}
            gap={1}
            onClick={(e) => showOnMap(e, drone_nest)}
            sx={{ cursor: "pointer" }}
          >
            <Typography variant="h5">Show on Map</Typography>
            <TurnRightRoundedIcon sx={{ fontSize: 16 }} />
          </Stack>
        ) : null}
      </Stack>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ width: "100%" }}
        gap={1}
      >
        {isShowDroneNest ? <Detail drone_nest={drone_nest} /> : null}
        <Detail1 isShowDroneNest={isShowDroneNest} battery_level={battery_level} weapon={weapon} />
      </Stack>
    </StyleStack>
  );
};

export default React.memo(DroneDetail);

const Detail = React.memo((props) => {
  const { drone_nest } = props;
  return (
    <Stack
      direction={"row"}
      gap={1}
      alignItems={"center"}
      sx={{ width: 0, flexGrow: 1 }}
    >
      <OverflowTooltip variant="subtitle1" sx={{ whiteSpace: "nowrap" }}>
        {drone_nest?.floor?.label || "Unknown Floor"}
      </OverflowTooltip>
      <Divider orientation="vertical" flexItem sx={{ borderRadius: 0.25 }} />
      <DroneNestIcon titleAccess="Drone Nest Location" sx={{ fontSize: 18 }} />
      <OverflowTooltip
        variant="subtitle1"
        // sx={(theme) => ({
        //   ...theme.mixins.overflow,
        //   // width: 0,
        //   // flexGrow: 1
        // })}
      >
        In nest{" "}
        <Typography component={"span"} sx={{ color: "#51555C" }}>
          {drone_nest?.name || ""}
          {!!drone_nest?.display_id ? " - " + drone_nest?.display_id : ""}
        </Typography>
      </OverflowTooltip>
    </Stack>
  );
});
const Detail1 = React.memo(({ isShowDroneNest = true, battery_level = 0, weapon = [] }) => {
  let remaining = 0;
  let total = 0;
  let droneType = {};

  try {
    if (!!weapon && Array.isArray(weapon)) {
      for (const element of weapon) {
        remaining += element.rounds_remaining;
        total += element.total_rounds;

        if (!droneType.icon) {
          const match = droneTypes.find((d) => d.value === element.type);
          if (match) droneType = match;
        }
      }
    }
  } catch (error) {
    console.info("weapon data:", weapon);
    console.info("Error processing weapon data:", error);
  }
  const batteryColor =
    battery_level >= 60
      ? "#00FF47"
      : battery_level >= 30
        ? "#FFD700"
        : "#FF4D4F";

  return (
    <Stack
      direction={"row"}
      gap={1}
      alignItems={"center"}
      justifyContent={"flex-end"}
      sx={(theme) => ({ flexGrow: isShowDroneNest?0:1, ...theme.mixins.overflow })}
    >
      {total > 0 ? (
        <OverflowTooltip variant="subtitle1">
          {remaining}/{total}
        </OverflowTooltip>
      ) : (
        <OverflowTooltip variant="subtitle1" sx={{ color: "#999" }}>
          No weapons
        </OverflowTooltip>
      )}
      <DroneIcon icon={droneType?.icon} />
      <OverflowTooltip variant="subtitle1">{droneType?.label}</OverflowTooltip>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ borderRadius: 0.25, marginY: 0.5 }}
      />
      <OverflowTooltip variant="subtitle1">
        {battery_level || 0}%
      </OverflowTooltip>
      <BatteryIcon titleAccess="Battery Level" sx={{ color: batteryColor }} />
    </Stack>
  );
});
